import { OrderUpsell } from '@models/order-upsell';

export const ClindamycinUpsell: OrderUpsell = {
  id: 2800,
  name: 'Clindamycin 300mg (Cleocin)',
  slug: 'clindamycin-300mg-cleocin',
  price: 7000,
  upsell_price: 0,
};

export const DoxyPepStdUpsell: OrderUpsell = {
  id: 3361,
  name: 'DoxyPEP Treatment (STD)',
  slug: 'doxypep-treatment-std',
  price: 4900,
  upsell_price: 4900,
  recommended: false,
  description: '',
};

// Not in use?
export const DoxyPepUpsell: OrderUpsell = {
  id: 2640,
  name: 'DoxyPEP Treatment',
  slug: 'doxy-pep',
  price: 4900,
  upsell_price: 4900,
  recommended: false,
  description: '',
};

export const EdTreatmentUpsell: OrderUpsell = {
  id: 3734,
  name: 'ED Giftcard',
  slug: 'ed-giftcard',
  price: 6900,
  upsell_price: 6900,
  recommended: false,
  description: '',
};

export const FemaleCondomUpsell: OrderUpsell = {
  id: 3876,
  name: 'Female Condom',
  slug: 'female-condom',
  price: 0,
  upsell_price: 0,
  recommended: false,
  description: '',
};

export const FreeTestosteronePanelTest: OrderUpsell = {
  id: 3695,
  name: 'Free Testosterone Panel',
  price: 0,
  slug: 'free-testosterone-panel',
  upsell_price: 0,
};

export const LetTheDoctorDecideUti: OrderUpsell = {
  id: 3082,
  name: 'Let the doctor decide (UTI)',
  slug: 'let-the-doctor-decide-uti',
  price: 7000,
  upsell_price: 0,
};

export const MetronidazoleUpsell: OrderUpsell = {
  id: 2792,
  name: 'Metronidazole 500mg (Flagyl)',
  slug: 'flagyl',
  price: 7000,
  upsell_price: 0,
};

export const MycoplasmaGenitaliumUpsell: OrderUpsell = {
  id: 1133,
  name: 'Mycoplasma genitalium',
  slug: 'mycoplasma-genitalium-naa-urine',
  price: 7900,
  upsell_price: 7900,
  recommended: false,
  description: '',
};

export const MycoplasmaHominisUreaplasmaUpsell: OrderUpsell = {
  id: 1203,
  name: 'Mycoplasma Hominis / Ureaplasma urealyticum',
  slug: 'mycoplasma-hominis-ureaplasma-urealyticum',
  price: 47900,
  upsell_price: 7900,
  recommended: false,
  description: '',
};

export const PartialResultsDeliveryUpsell: OrderUpsell = {
  id: 2657,
  name: 'Partial Results Delivery',
  slug: 'partial-results-delivery',
  price: 2900,
  upsell_price: 2900,
  recommended: false,
  description: '',
};

export const PriorityProcessingUpsell: OrderUpsell = {
  id: 3628,
  name: 'Priority Processing',
  slug: 'priority-processing',
  price: 1000,
  upsell_price: 1000,
};
